import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HubMonitorService {
  public openHubMonitor: Subject<void> = new Subject<void>();

  requestOpenHubMonitor() {
    this.openHubMonitor.next();
  }
}
